var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFm = function SvgIconFm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.001 5.218.518 1.594h1.676l-1.356.985.518 1.594-1.356-.985-1.356.985.518-1.594-1.356-.985h1.676zM5.218 12l1.594-.518V9.805l.985 1.357 1.595-.519L8.406 12l.986 1.356-1.595-.518-.985 1.356v-1.676zM12.001 18.783l-.518-1.594H9.807l1.356-.986-.518-1.594 1.356.985 1.356-.985-.518 1.594 1.356.986H12.52zM18.783 12l-1.594.518v1.676l-.985-1.356-1.595.518.986-1.357-.986-1.356 1.595.518.985-1.356v1.677z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconFm;